import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/SbLogo.svg'


const _hoisted_1 = { class: "flex evenly align-e" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SocialMediaIcons = _resolveComponent("SocialMediaIcons")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.navContainer)
  }, [
    _createVNode(_component_router_link, {
      to: "/",
      class: _normalizeClass(_ctx.$style.homeLink)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            class: _normalizeClass(_ctx.$style.SBLogo),
            src: _imports_0,
            alt: "My Image"
          }, null, 2)
        ])
      ]),
      _: 1
    }, 8, ["class"]),
    _createElementVNode("div", {
      id: "navLinkContainer",
      class: _normalizeClass([_ctx.$style.navLinkContainer, "flex evenly"]),
      style: _normalizeStyle({ display: _ctx.mobileNavDisplay })
    }, [
      (_ctx.isMobileView)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.$style.navLink),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateToRoute('/')))
          }, "Home", 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateToRoute('/projects'))),
        class: _normalizeClass(_ctx.$style.navLink)
      }, "Projects", 2),
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateToRoute('/experience'))),
        class: _normalizeClass(_ctx.$style.navLink)
      }, "Experience", 2),
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateToRoute('/contact'))),
        class: _normalizeClass(_ctx.$style.navLink)
      }, "Contact", 2),
      (_ctx.isMobileView)
        ? (_openBlock(), _createBlock(_component_SocialMediaIcons, { key: 1 }))
        : _createCommentVNode("", true)
    ], 6),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.mobileMenuHamburgerContainer)
    }, [
      _createElementVNode("input", {
        type: "checkbox",
        id: "nav-toggle",
        class: _normalizeClass(_ctx.$style.active)
      }, null, 2),
      _createElementVNode("label", {
        htmlFor: "nav-toggle",
        class: _normalizeClass(_ctx.$style.hamburgerMenu),
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleNav && _ctx.toggleNav(...args)))
      }, _hoisted_3, 2)
    ], 2)
  ], 2))
}